import { createContext } from 'react'
import { noop } from 'utils'

export const FilterContext = createContext({
  value: '',
  setValue: noop,
  selectedMenu: undefined,
  setSelectedMenu: noop,
  menuVisible: false,
  setMenuVisible: noop,
  formVisible: false,
  showFilterFormLayer: noop,
  hideFilterFormLayer: noop,
  filterRef: {},
  filterForm: undefined,
  setFilterForm: noop,
  addVisible: false,
  isOverflow: false,
  setOverflow: noop,
  showDeleteSavedFilterConfirm: noop,
})
